import { Moon, Sun } from 'lucide-react';
import { useTheme } from './ThemeProvider';
import { Button } from './Button';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <Button
      variant="ghost"
      size="sm"
      className="w-10 h-10 px-0 rounded-full flex items-center justify-center text-text-secondary hover:text-text-primary"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      aria-label="Toggle theme"
      style={{ perspective: '500px' }}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-5.5 h-5.5"
      >
        {/* Sun Rays - visible in light mode, shrinks & spins away in dark mode */}
        <g
          style={{
            transition: 'transform 700ms cubic-bezier(0.4, 0, 0.2, 1), opacity 700ms',
            transform: isDark ? 'rotate(90deg) scale(0)' : 'rotate(0deg) scale(1)',
            opacity: isDark ? 0 : 1,
            transformOrigin: 'center',
          }}
        >
          <line x1="12" y1="2" x2="12" y2="4" />
          <line x1="12" y1="20" x2="12" y2="22" />
          <line x1="4" y1="12" x2="2" y2="12" />
          <line x1="22" y1="12" x2="20" y2="12" />
          <line x1="4.93" y1="19.07" x2="6.34" y2="17.66" />
          <line x1="17.66" y1="6.34" x2="19.07" y2="4.93" />
          <line x1="4.93" y1="4.93" x2="6.34" y2="6.34" />
          <line x1="17.66" y1="17.66" x2="19.07" y2="19.07" />
        </g>

        {/* Core Circle - grows from sun core to contrast circle */}
        <g
          style={{
            transition: 'transform 700ms cubic-bezier(0.4, 0, 0.2, 1)',
            transform: isDark ? 'rotate(-180deg) rotateY(180deg)' : 'rotate(0deg) rotateY(0deg)',
            transformStyle: 'preserve-3d',
            transformOrigin: 'center',
          }}
        >
          <circle
            cx="12"
            cy="12"
            r={isDark ? 9 : 5}
            style={{ transition: 'r 700ms cubic-bezier(0.4, 0, 0.2, 1)' }}
          />
          <clipPath id="shutter">
            <rect
              x="0"
              y="0"
              height="100%"
              style={{
                width: isDark ? '50%' : '0%',
                transition: 'width 700ms cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            />
          </clipPath>
          <circle
            cx="12"
            cy="12"
            r={isDark ? 9 : 5}
            fill="currentColor"
            stroke="none"
            clipPath="url(#shutter)"
            style={{ transition: 'r 700ms cubic-bezier(0.4, 0, 0.2, 1)' }}
          />
        </g>
      </svg>
    </Button>
  );
}
